export const CONTENT_PADDING = 30;

export const URL_PRIVACY_POLICY = 'https://www.braunschweig.de/datenschutz.php';
